import { type ContextDto, IdentityUserStatus } from "Infrastructure/Api/Api";
import { AccessRoleCodes } from "Models/AccessRoleCodes";

export const getIsActiveCustomerContext = ({
  accessRoleCode,
  status,
}: ContextDto) =>
  accessRoleCode === AccessRoleCodes.Customer &&
  status === IdentityUserStatus.Active;
